import type { DecisionEngineDestinationDefinition } from "./definition";
import { hightouchMappingWithTags } from "./sync-config-helpers";

export const attentiveDefinition: DecisionEngineDestinationDefinition = {
  destinationType: "attentive",
  category: "event",
  generateSyncConfig: ({ channelConfig, messageTags }) => ({
    object: "custom_event",
    externalIdMapping: {
      from: "external_id",
      to: channelConfig.recipientType === "phone" ? "phone" : "email",
    },
    eventType: "hightouch_interaction",
    mappings: [
      hightouchMappingWithTags(messageTags),
      { type: "standard", from: "campaign_id", to: "message_identifier" },
    ],
    externalEventId: { from: "id" },
  }),
  syncStrategy: {
    supportsChannelLevelSync: false,
  },
};
